import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import reviewImg from "../../images/review-img.png"
import "./assets/styles/_index.scss";
const { ContentModule } = require("@starberry/gatsby-theme-utils/Modules/ContentModule")

const ReviewModule = (props) => {
    return (
        <div className="review-module d-flex align-items-center">
            {props.banner_review_image ? <img src={props.banner_review_image?.url} alt="" /> : ""}
            <div className="review">{props.banner_review ? <ContentModule Content={props.banner_review?.data?.banner_review} /> : ""}</div>
            {/* <p>“Very good business center. Friendly and supportive staff. Decently priced and located in a prime area.”</p> */}
        </div>
    );
};

export default ReviewModule;
